import { render, staticRenderFns } from "./BaseSpacer.vue?vue&type=template&id=4b1d80fb&"
import script from "./BaseSpacer.vue?vue&type=script&lang=js&"
export * from "./BaseSpacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1d80fb')) {
      api.createRecord('4b1d80fb', component.options)
    } else {
      api.reload('4b1d80fb', component.options)
    }
    module.hot.accept("./BaseSpacer.vue?vue&type=template&id=4b1d80fb&", function () {
      api.rerender('4b1d80fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Base/BaseSpacer.vue"
export default component.exports